import React from "react";
import { NavLink } from "react-router-dom";
import "./navbtn.css";

const Navbtn = ({ link, page }) => {
  return (
    <NavLink
      to={link}
      end={link === "/"}
      className={({ isActive }) =>
        `navbtn ${isActive ? "active" : ""}`
      }
    >
      {page}
    </NavLink>
  );
};

export default Navbtn;